<!-- Daily Check-In — AIO-80387 -->

<div id="kt_content" class="kt-content kt-grid__item kt-grid__item--fluid">

  <!-- ============ BASIC SETTINGS ============ -->
  <!-- No head here, matching 19.1 Partner Page's Display Page panel: the two sections are
       separated by the portlet gap, not by a title bar. -->
  <div class="kt-portlet kt-portlet--mobile dci-basic-portlet">
    <div class="kt-portlet__body">
      <div class="dci-basic">

        <div class="dci-basic__field">
          <label class="dci-label">{{ 'Enable Check-In' | translate }}</label>
          <div class="dci-toggle-row">
            <span class="dci-switch" [class.dci-switch--on]="settingsForm.value.status"
                  [class.dci-switch--disabled]="!canEditDailyCheckInSettings || loading"
                  (click)="canEditDailyCheckInSettings && !loading && settingsForm.patchValue({ status: settingsForm.value.status ? 0 : 1 })">
              <span class="dci-switch__knob"></span>
            </span>
            <span class="dci-toggle-text" [class.dci-toggle-text--on]="settingsForm.value.status">
              {{ (settingsForm.value.status ? 'On — visible to players' : 'Off — Hidden') | translate }}
            </span>
          </div>
        </div>

        <div class="dci-basic__field">
          <label class="dci-label">
            {{ 'Missed Day Rule' | translate }}
            <i class="fas fa-info-circle dci-info" matTooltipClass="dci-tooltip" matTooltipHideDelay="0"
               [matTooltip]="resetModeTooltip"></i>
          </label>
          <select class="form-control"
                  [disabled]="!canEditDailyCheckInSettings || loading"
                  (change)="onResetModeChange($event)">
            <option *ngFor="let mode of resetModes" [value]="mode.value"
                    [selected]="mode.value === +settingsForm.value.reset_on_missed">{{ mode.label | translate }}</option>
          </select>
        </div>

        <div class="dci-basic__field">
          <label class="dci-label">
            {{ 'Floating Icon Image' | translate }}<span class="text-danger">*</span>
          </label>
          <!-- Same box as 19.1 Partner Page's Floating Icon Image: a dashed "Upload" drop-zone
               while empty, the image filling a solid box with a trash overlay once attached. -->
          <div class="dci-iconbox" [class.dci-iconbox--has]="settingsForm.value.icon_path && !iconUploading"
               [class.dci-iconbox--invalid]="settingsLoaded && !settingsForm.value.icon_path && !iconUploading"
               [class.dci-upload--disabled]="!canEditDailyCheckInSettings || loading">

            <span class="dci-iconbox__empty" *ngIf="iconUploading">
              <i class="fas fa-circle-notch fa-spin"></i>
            </span>

            <label class="dci-iconbox__empty mb-0" *ngIf="!settingsForm.value.icon_path && !iconUploading">
              <i class="fas fa-upload"></i>
              <span>{{ 'Upload' | translate }}</span>
              <input type="file" hidden accept="image/*"
                     [disabled]="!canEditDailyCheckInSettings || loading"
                     (change)="onIconSelected($event)">
            </label>

            <ng-container *ngIf="settingsForm.value.icon_path && !iconUploading">
              <img [src]="settingsForm.value.icon_path" alt=""
                   [title]="'Click to preview' | translate" (click)="openIconPreview()">
              <button *ngIf="canEditDailyCheckInSettings" type="button" class="dci-iconbox__rm"
                      [title]="'Remove image' | translate"
                      [disabled]="loading" (click)="clearIcon()">
                <i class="fas fa-trash-alt"></i>
              </button>
            </ng-container>
          </div>
          <!-- Mandatory: says why Save is locked instead of leaving a dead button. -->
          <span class="dci-set-hint" *ngIf="settingsLoaded && !settingsForm.value.icon_path && !iconUploading">
            {{ '*Required' | translate }}
          </span>
        </div>

        <div class="dci-basic__field">
          <label class="dci-label">{{ 'Missed Icon Image' | translate }}</label>
          <!-- Optional: when empty the player site shows its default missed icon. -->
          <div class="dci-iconbox" [class.dci-iconbox--has]="settingsForm.value.missed_icon_path && !missedIconUploading"
               [class.dci-upload--disabled]="!canEditDailyCheckInSettings || loading">

            <span class="dci-iconbox__empty" *ngIf="missedIconUploading">
              <i class="fas fa-circle-notch fa-spin"></i>
            </span>

            <label class="dci-iconbox__empty mb-0" *ngIf="!settingsForm.value.missed_icon_path && !missedIconUploading">
              <i class="fas fa-upload"></i>
              <span>{{ 'Upload' | translate }}</span>
              <input type="file" hidden accept="image/*"
                     [disabled]="!canEditDailyCheckInSettings || loading"
                     (change)="onMissedIconSelected($event)">
            </label>

            <ng-container *ngIf="settingsForm.value.missed_icon_path && !missedIconUploading">
              <img [src]="settingsForm.value.missed_icon_path" alt="">
              <button *ngIf="canEditDailyCheckInSettings" type="button" class="dci-iconbox__rm"
                      [title]="'Remove image' | translate"
                      [disabled]="loading" (click)="clearMissedIcon()">
                <i class="fas fa-trash-alt"></i>
              </button>
            </ng-container>
          </div>
          <span class="dci-set-hint dci-set-hint--muted" *ngIf="settingsLoaded && !settingsForm.value.missed_icon_path && !missedIconUploading">
            {{ 'Optional — default icon used when empty' | translate }}
          </span>
        </div>

        <div class="dci-basic__actions">
          <button *ngIf="canEditDailyCheckInSettings" type="button" class="btn btn-brand btn-icon-sm"
                  [disabled]="settingsLoading || loading || !canSaveSettings" (click)="saveSettings()">
            <i class="fas fa-save"></i>{{ 'Save' | translate }}
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- ============ REWARD SCHEDULE ============ -->
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <!-- <small> is the theme's own subtitle slot inside a portlet title: lighter weight,
             muted colour, sits on the same line. -->
        <h3 class="kt-portlet__head-title kt-font-bolder">
          {{ 'Reward Schedule' | translate }}
          <small>{{ 'Combine member groups into sets that share one schedule.' | translate }}</small>
        </h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <button *ngIf="canCreateDailyCheckInSet" type="button" class="btn btn-icon-sm dci-btn-soft mr-2"
                [disabled]="loading || !hasEditableCurrency" (click)="addSet()">
          <i class="fas fa-plus"></i>{{ 'Add Set' | translate }}
        </button>
        <button *ngIf="canSaveSchedule" type="button"
                class="btn btn-brand btn-icon-sm"
                [disabled]="scheduleLoading || loading || !hasUnsavedSets || !hasEditableCurrency" (click)="saveSchedule()">
          <i class="fas fa-save"></i>{{ 'Save' | translate }}
        </button>
      </div>
    </div>

    <div class="kt-portlet__body">

      <div class="kt-section">
        <div class="row align-items-center">
          <div class="col-md-8">
            <!-- innerHTML, not interpolation: the <strong> tags stay inside the single
                 translation key so word order can change per language without splitting the
                 sentence into fragments. The string is a literal — no user input reaches it. -->
            <span class="kt-font-sm kt-font-dark"
                  [innerHTML]="'Each <strong>Set</strong> groups one or more member groups that share the same 7-day schedule. Every day is configured per <strong>currency</strong> (switch below) — reward type, amount, promo, prize and image are all independent, so Day 1 can be a credit in one currency and a prize in another. Leave a currency untouched to skip it; any currency you start filling must be complete.' | translate">
            </span>
          </div>
          <div class="col-md-4 d-flex align-items-start justify-content-md-end mt-2 mt-md-0">
            <label class="kt-form__label col-form-label mb-0 mr-2 text-nowrap">
              {{ 'Editing currency' | translate }}:
            </label>
            <div class="text-right">
              <!-- Locked while this currency has unsaved edits: switching would leave a
                   half-finished currency behind, and only a saved one is complete. -->
              <select class="form-control dci-ccy-select" [ngModel]="selectedCurrencyId"
                      [disabled]="hasUnsavedSets"
                      (ngModelChange)="onCurrencyChange($event)">
                <option *ngFor="let currency of editableCurrencies" [value]="currency.id">
                  {{ currency.code }} — {{ currency.symbol }}
                </option>
              </select>
              <span class="dci-set-hint dci-set-hint--ccy" *ngIf="hasUnsavedSets">
                {{ "*Click 'Save' before switching currency" | translate }}
              </span>
              <!-- Check-in runs currencies this operator is not assigned. Their cells stay in
                   memory and are carried through on save — they just cannot be opened here. -->
              <span class="dci-set-hint" *ngIf="!loading && !editableCurrencies.length">
                {{ '*No currency assigned to your account' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-section">
        <div class="kt-section__content">
          <div class="table-responsive dci-scroll" [class.dci-scroll--room]="groupDropdownOpen">
            <table class="table table-bordered table-hover dci-grid">
              <thead>
                <tr>
                  <th class="dci-setcol">{{ 'Member Groups in Set' | translate }}</th>
                  <th *ngFor="let day of days" class="text-center">
                    {{ 'DAY' | translate }} {{ day }}<span *ngIf="isFinalDay(day)" class="dci-star">&#11088;</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let set of visibleSets">

                  <!-- set column -->
                  <td class="dci-setcol" [class.dci-setcol--open]="openGroupDropdownSet === set">
                    <div class="d-flex align-items-center mb-2">
                      <span class="dci-switch dci-switch--sm" [class.dci-switch--on]="set.status"
                            [class.dci-switch--disabled]="!canEditSet(set)"
                            (click)="canEditSet(set) && toggleSetStatus(set)">
                        <span class="dci-switch__knob"></span>
                      </span>
                      <!-- (input), not (change): change only fires on blur, so the unsaved hint
                           and the Save button stayed dead until the operator clicked away. -->
                      <input type="text" class="form-control mx-2 dci-setname"
                             [class.dci-invalid]="set.nameInvalid" [value]="set.name"
                             [disabled]="!canEditSet(set)"
                             (input)="onSetNameChange(set, $event.target.value)">
                      <button *ngIf="canCreateDailyCheckInSet" type="button"
                              class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm"
                              [matTooltip]="('Copy this set\'s ' | translate) + currencyCode(selectedCurrencyId) + (' schedule into a new set' | translate)"
                              [disabled]="!canEditDailyCheckInSet"
                              (click)="duplicateSet(set)">
                        <i class="far fa-copy"></i>
                      </button>
                      <button *ngIf="canDeleteDailyCheckInSet" type="button"
                              class="btn btn-outline-hover-danger btn-elevate btn-sm btn-icon btn-icon-sm ml-1"
                              [matTooltip]="('Clear the ' | translate) + currencyCode(selectedCurrencyId) + (' schedule (removes the set when it is the last currency)' | translate)"
                              (click)="removeSet(set)">
                        <i class="far fa-trash-alt"></i>
                      </button>
                    </div>

                    <div class="dci-chips">
                      <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide dci-chip"
                            *ngFor="let groupId of groupIdsFor(set)">
                        {{ groupName(groupId) }}
                        <a href="javascript:;" class="ml-1" *ngIf="canEditSet(set)"
                           (click)="removeGroup(set, groupId)">&times;</a>
                      </span>

                      <!-- ng-select rather than a plain <select>: it filters as you type, which
                           matters with ~60 member groups. [ngModel] is pinned to null so the
                           control snaps back to the placeholder after each pick. -->
                      <!-- Same widget as the Member Group filter on 3.2.1 Promotion Codes.
                           It renders its panel inline, so .dci-scroll would clip it — the
                           (onOpen)/(onClose) pair widens that clip box while the list is up. -->
                      <angular2-multiselect class="dci-addgroup"
                                            *ngIf="canEditSet(set) && unassignedGroups.length"
                                            [data]="unassignedGroups"
                                            [settings]="addGroupDropdownSettings"
                                            [(ngModel)]="set.addGroupSelection"
                                            (onOpen)="onAddGroupOpen(set)"
                                            (onClose)="onAddGroupClose(set)">
                      </angular2-multiselect>

                      <!-- Turns into a red requirement once a save has been attempted: a set
                           with a schedule and no group pays nobody. See validationErrors(). -->
                      <span class="kt-font-sm" *ngIf="!groupIdsFor(set).length"
                            [class.kt-font-dark]="!set.groupsInvalid"
                            [class.dci-required]="set.groupsInvalid">
                        {{ (set.groupsInvalid ? '*Add at least one member group' : 'No groups yet') | translate }}
                      </span>
                    </div>

                    <!-- A set with no id has never been sent to the API, so the prompt tells the
                         operator it will be created rather than updated. -->
                    <span class="dci-set-hint" *ngIf="isDirty(set)">
                      {{ (set.id ? "*Click 'Save' to save changes" : "*Click 'Save' to add set") | translate }}
                    </span>
                  </td>

                  <!-- day cells -->
                  <!-- The outline lives on each FIELD below, not here: a cell-wide class made
                       every control in the column red when only one box was actually at fault. -->
                  <td *ngFor="let day of days" class="dci-cell">
                    <ng-container *ngIf="scheduleFor(set, day) as schedule">

                      <!-- Every cell starts as No Reward — there is no "not set" placeholder.
                           [ngValue] rather than [value] so the option binds the number 0, which
                           a [value] binding would stringify. -->
                      <select class="form-control mb-2" [ngClass]="'dci-type--' + schedule.reward_type"
                              [class.dci-invalid]="isFieldInvalid(schedule, 'reward_type')"
                              [ngModel]="schedule.reward_type"
                              [disabled]="!canEditSet(set)"
                              (ngModelChange)="onRewardTypeChange(set, day, $event)">
                        <option *ngFor="let type of rewardTypes" [ngValue]="type.id">{{ type.name | translate }}</option>
                      </select>

                      <!-- credit: symbol prefix + amount -->
                      <div class="input-group mb-2" *ngIf="schedule.reward_type == rewardType.Credit"
                           [class.dci-invalid]="isFieldInvalid(schedule, 'amount')">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ currencySymbol }}</span>
                        </div>
                        <!-- AppTwoDigitDecimal is the house money input: it blocks anything that
                             isn't digits with up to 2 decimals, so a minus sign never reaches
                             the model. Kept as type="text" — the directive reads selectionStart,
                             which a number input doesn't expose. -->
                        <input type="text" class="form-control" AppTwoDigitDecimal
                               [placeholder]="amountPlaceholder"
                               [value]="schedule.amount"
                               [disabled]="!canEditSet(set)"
                               (keydown)="onAmountKeydown($event)"
                               (change)="onAmountChange(set, day, $event.target)">
                        <!-- IDR is typed in thousands against a fixed tail, matching the player
                             deposit form. The box holds 10, the database holds 10000. -->
                        <div class="input-group-append" *ngIf="amountScaleSuffix">
                          <span class="input-group-text">{{ amountScaleSuffix }}</span>
                        </div>
                      </div>
                      <!-- Names the range the moment the box loses focus, so an out-of-range
                           amount is not a mystery red border. -->
                      <div class="dci-amount-hint" *ngIf="amountRangeHint(schedule) as hint">{{ hint }}</div>

                      <!-- promo -->
                      <ng-container *ngIf="schedule.reward_type == rewardType.Promo">
                        <!-- Searchable, and narrowed to promotions that run in this currency and
                             target this set's member groups — see refreshPromotionOptions(). -->
                        <!-- Locked until the set has a member group: the list is filtered BY
                             those groups, so with none it would offer only the promotions that
                             target no group at all — a misleading subset. It is also locked when
                             the operator may not edit this set — see promotionSettings(). -->
                        <angular2-multiselect class="dci-promo mb-2"
                                              [class.dci-invalid]="isFieldInvalid(schedule, 'promotion_id')"
                                              [data]="set.promotionOptions || []"
                                              [settings]="promotionSettings(set)"
                                              [(ngModel)]="schedule.promotion_selection"
                                              [ngModelOptions]="{ standalone: true }"
                                              (onOpen)="groupDropdownOpen = true"
                                              (onClose)="groupDropdownOpen = false"
                                              (onSelect)="onPromotionSelect(set, day, $event)"
                                              (onDeSelect)="onPromotionDeselect(set, day)">
                        </angular2-multiselect>
                        <span class="dci-set-hint mb-2" *ngIf="!groupIdsFor(set).length">
                          {{ '*Add a member group before picking a promotion' | translate }}
                        </span>
                        <span class="kt-font-danger kt-font-sm d-block mb-2"
                              *ngIf="schedule.promotion_available === false">
                          <i class="fas fa-exclamation-triangle"></i>
                          {{ 'Promotion is inactive or removed' | translate }}
                        </span>
                        <!-- Names the currency or member group that rules this promotion out, so
                             the red outline is not a mystery on a grid the operator just opened. -->
                        <span class="kt-font-danger kt-font-sm d-block mb-2"
                              *ngIf="schedule.promotionIssueText">
                          <i class="fas fa-exclamation-triangle"></i>
                          {{ schedule.promotionIssueText }}
                        </span>
                      </ng-container>

                      <!-- no reward: an optional label, stored in the same field as a prize name -->
                      <input *ngIf="schedule.reward_type === rewardType.None" class="form-control mb-2"
                             type="text" maxlength="191" [placeholder]="'Label (optional)' | translate"
                             [value]="schedule.prize_name || ''"
                             [disabled]="!canEditSet(set)"
                             (change)="onScheduleFieldChange(set, day, 'prize_name', $event.target.value)">

                      <!-- prize -->
                      <input *ngIf="schedule.reward_type == rewardType.Prize" class="form-control mb-2"
                             [class.dci-invalid]="isFieldInvalid(schedule, 'prize_name')"
                             type="text" maxlength="191" [placeholder]="'Prize name' | translate"
                             [value]="schedule.prize_name || ''"
                             [disabled]="!canEditSet(set)"
                             (change)="onScheduleFieldChange(set, day, 'prize_name', $event.target.value)">

                      <!-- image — shown once the cell has a type. `!== null` rather than a
                           truthiness test: No Reward is 0, which would otherwise hide it. -->
                      <label class="dci-cellimg"
                             *ngIf="schedule.reward_type !== null && schedule.reward_type !== undefined"
                             [class.dci-invalid]="isFieldInvalid(schedule, 'image_path')"
                             [class.dci-cellimg--has]="schedule.image_path"
                             [class.dci-upload--disabled]="!canEditSet(set) || loading">
                        <img *ngIf="schedule.image_path" [src]="schedule.image_path" alt="">
                        <span *ngIf="!schedule.image_path" class="kt-font-sm">
                          <i class="fas fa-plus"></i> {{ 'Image' | translate }}
                        </span>
                        <input type="file" hidden accept="image/*"
                               [disabled]="!canEditSet(set) || loading"
                               (change)="onCellImageSelected($event, set, day)">
                        <button *ngIf="schedule.image_path && canEditSet(set)" type="button" class="dci-cellimg__rm"
                                (click)="$event.preventDefault(); $event.stopPropagation(); clearCellImage(set, day)">&times;</button>
                      </label>

                    </ng-container>
                  </td>

                </tr>

                <kt-fallback-row [collection]="visibleSets" [columns]="dayCount + 1"></kt-fallback-row>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="kt-section mb-0" *ngIf="!loading">
        <div class="dci-chips">
          <ng-container *ngIf="unassignedGroups.length; else allAssigned">
            <span class="kt-font-sm kt-font-dark mr-2">{{ 'Unassigned (no schedule yet):' | translate }}</span>
            <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide dci-chip dci-chip--warn"
                  *ngFor="let group of unassignedGroups">{{ group.name }}</span>
          </ng-container>
          <ng-template #allAssigned>
            <span class="kt-font-sm kt-font-dark">{{ 'All member groups are assigned to a set.' | translate }}</span>
          </ng-template>
        </div>
      </div>

    </div>
  </div>

</div>

<!-- Enlarged floating-icon preview — the box is input-height, so the icon is too small to
     judge in place.

     This wrapper is moved to <body> on init (see ngOnInit). ContentAnimateDirective animates a
     translateY on the layout's .kt-container and leaves the transform in place, which makes
     that element the containing block for every position: fixed descendant — left in the
     template, the backdrop would stop at the content area instead of covering the viewport,
     and the image would centre on the content area rather than the screen. -->
<div #iconPreviewHost>
  <div class="dci-img-preview" *ngIf="showIconPreview" (click)="closeIconPreview()">
    <img [src]="settingsForm.value.icon_path" alt="" (click)="$event.stopPropagation()">
  </div>
</div>

<!-- Save / delete confirmations. The data service pushes each write response's message array. -->
<kt-swal-alert [message]="messages$ | async"></kt-swal-alert>
